/**
 * The one surface everything over the map wears, at one weight. Which panel
 * is open is told by its size and nothing else.
 *
 * Nearly opaque, so what is on it always reads, with a trace of the map
 * through it so it still sits on the map. Never blurred: a blur is sampled
 * again on every frame anything moves, and drops out while anything around
 * it animates.
 */
export const panelSurface = "rounded-2xl bg-background/95 shadow-lg ring-1 ring-foreground/10";

/** What one of them does when it is the thing you are about to click. */
export const panelSurfaceHover = "hover:bg-background";

/**
 * The same surface over a page or a scrim, where there is nothing worth
 * seeing through it: a menu, a dialog.
 */
export const solidSurface = "rounded-2xl bg-popover shadow-lg ring-1 ring-foreground/10";

/**
 * A card inside a panel: a slightly raised ground for one thing, or for a
 * group of things that belong together.
 *
 * This is how a panel is divided. Nothing is ever separated by a line —
 * a rule drawn across a panel says "these are different" and takes a pixel
 * of ink to do it, where a change of ground says the same thing and gives
 * what is on it somewhere to sit.
 *
 * Its radius plus the padding of whatever holds it comes to that thing's own
 * radius, all the way down, so every corner in a panel is concentric.
 */
export const panelCard = "rounded-xl bg-foreground/5";
